import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { MessageBotIcon } from 'images/svg';

interface Props {
  frontChat: any;
  isInitialized: any;
  className?: string;
}

const PageFrontChatToggle = (props: Props) => {
  const { frontChat, isInitialized, className } = props;

  const [isFrontChatVisible, setIsFrontChatVisible] = useState(false);

  const toggleButtonClasses = classNames('front-chat-toggle', className);

  const onToggleChat = () => {
    if (!frontChat) {
      return;
    }

    if (isFrontChatVisible) {
      frontChat('hide');
    } else {
      frontChat('show');
    }

    setIsFrontChatVisible(!isFrontChatVisible);
  };

  useEffect(() => {
    if (!isInitialized) {
      return;
    }

    const unbind = frontChat?.('onWindowVisibilityChanged', data =>
      setIsFrontChatVisible(data.is_window_visible),
    );

    return () => {
      unbind();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialized]);

  if (!isInitialized) {
    return null;
  }

  return (
    <div className={toggleButtonClasses}>
      <button
        onClick={onToggleChat}
        className="app-button front-chat-toggle__btn"
      >
        <MessageBotIcon />
      </button>
    </div>
  );
};

export default PageFrontChatToggle;
